import defaultTheme from './defaultTheme.esm.js';
import THEME_ID from './identifier.esm.js';
import useThemeProps$1 from '../../system/esm/useThemeProps/useThemeProps.esm.js';

function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme,
    themeId: THEME_ID
  });
}

export { useThemeProps as default };
